module.exports = __webpack_public_path__ + "f6bf99dffe22e2daf6a2755c93aea513.pdf";